module.exports = __webpack_public_path__ + "static/img/img_wuzhanghao.7d0a18c4.png";